import {
    EVENT_SET_DATA,
    EVENT_SET_ERROR,
    EVENT_SET_OWNERSHIP_DATA,
    EVENT_SET_OWNERSHIP_ERROR,
} from './event-manager.constants';
import { Dispatch } from 'types/dispatch';
import { IEventRequest, IOwnershipRequest, IEventResponse, IEventOwnershipResponse } from './event-manager.service';
import EventManagerError from './event-manager-error';

import EventManagerService from './event-manager.service';

const setEventData = (payload: IEventResponse) => ({
    type: EVENT_SET_DATA,
    payload
});

export const setEventError = (payload: EventManagerError) => ({
    type: EVENT_SET_ERROR,
    payload
});

const setOwnershipData = (payload: IEventOwnershipResponse) => ({
    type: EVENT_SET_OWNERSHIP_DATA,
    payload
});

export const setOwnershipError = (payload: EventManagerError) => ({
    type: EVENT_SET_OWNERSHIP_ERROR,
    payload
});

export const eventFetchData = (payload: IEventRequest) => (
    dispatch: Dispatch,
    getState: Function
) => {
    const { config } = getState();

    return EventManagerService.requestEvents(config.envName, payload)
        .then((response: IEventResponse) => {
            dispatch(setEventData(response));
        })
        .catch((error: EventManagerError) => {
            dispatch(setEventError(error));
        });
};

export const eventApplyOwnership = (payload: IOwnershipRequest) => (
    dispatch: Dispatch,
    getState: Function
) => {
    const { config } = getState();

    return EventManagerService.applyOwnership(config.envName, payload)
        .then((response: IEventOwnershipResponse) => {
            dispatch(setOwnershipData(response));
        })
        .catch((error: EventManagerError) => {
            dispatch(setOwnershipError(error));
        });
};

export type ownershipErrorAction = ReturnType<typeof setOwnershipError>;

export type Actions = ReturnType<typeof setEventData> | ReturnType<typeof setEventError>
| ReturnType<typeof setOwnershipData> | ReturnType<typeof setOwnershipError>;
